// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"14097ccb","787":"8517b185"}[chunkId] + ".chunk.js";
};